import classNames from "classnames/bind";
import { PlayBack } from "../../PlayBack";
import { useNavigate } from "react-router-dom";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import { useEffect } from "react";
import { getStatusParam } from "../../../utils";
import styles from "./PlaybackOneCamera.module.css";

const cx = classNames.bind(styles);

function PlaybackDesktopViewOneCam(params) {
    const navigate = useNavigate();
  const [dataStore, dispatch] = useStoreContext();

  useEffect(() => {
    const param = getStatusParam(["token", "cameraCode", "cameraName", "status"]);
    if (param?.token) {
      localStorage?.setItem('token', param?.token);
      sessionStorage?.setItem('token', param?.token);
      const url = new URL(window.location.href);
      if (param?.cameraCode) {
        navigate(url?.pathname + `?cameraCode=${param?.cameraCode}` + `&cameraName=${param?.cameraName}` + `&status=${param?.status}`);
      } else {
        navigate(url?.pathname);
      }
      window.location.reload();
    }
    if (param?.cameraCode && param?.cameraName && param?.status) {
      const dataAdd = {
        type: "cam",
        add: true,
        data: [
          {
            name: param?.cameraName,
            code: param?.cameraCode,
            status: false,
            camStatusActive:
              param?.status === "On"
                ? 1
                : param?.status === "Off"
                  ? 4
                  : 3,
          },
        ],
      };
      dispatch(actions.getListCodeCamera(dataAdd));
    }
  }, [])
    return (
      <div className={cx('wrapper')}>
        <PlayBack onlyVideo={true} />
        </div>
    )
}


export default PlaybackDesktopViewOneCam;